import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a106f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gray-title"
}
const _hoisted_2 = { class: "gray-text-check" }
const _hoisted_3 = { class: "gray-text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("移动分组")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = {
  key: 0,
  class: "img-list"
}
const _hoisted_7 = { class: "pic-title" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1637563771695",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "8244",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M694.037333 213.333333v64H234.666667v469.333334h512V512h64v234.666667a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V277.333333a64 64 0 0 1 64-64h459.370666z m136.746667 24.234667l45.098667 45.397333-343.722667 341.290667 0.128 0.128-46.592 1.578667 1.322667-47.274667 0.085333 0.106667 343.68-341.226667z",
      "p-id": "8245",
      fill: "#67C23A"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_n_checkbox_group = _resolveComponent("n-checkbox-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.checkList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_n_checkbox, {
                checked: _ctx.isChooseAll,
                "onUpdate:checked": _ctx.chooseAll,
                label: "全选"
              }, null, 8, ["checked", "onUpdate:checked"])
            ]),
            _createElementVNode("span", _hoisted_3, "已选择 " + _toDisplayString(_ctx.getCount()) + " 项内容", 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, { type: "text" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.deleteColor
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_n_checkbox_group, {
        value: _ctx.checkList,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkList) = $event)),
          _ctx.handleUpdateValue
        ]
      }, {
        default: _withCtx(() => [
          (_ctx.colorList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.colorList as any), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "img-block"
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.convertCss(item.mould))
                    }, null, 4),
                    _createVNode(_component_n_checkbox, {
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(item.mouldTitle), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]),
                    _createElementVNode("div", {
                      class: "edit-icon",
                      onClick: ($event: any) => (_ctx.editColorDialog(item))
                    }, _hoisted_10, 8, _hoisted_8)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "onUpdate:value"])
    ])
  ], 64))
}